module.exports = __webpack_public_path__ + "static/media/black cherry.71ea3615.png";